module.exports = __webpack_public_path__ + "static/media/menu-icon-white.9583c35e.svg";